export default __webpack_public_path__ + "static/media/freelancePage.f87c2394.png";